
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sensors",
      function () {
        return require("private-next-pages/sensors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sensors"])
      });
    }
  